import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h1 text-blue" }
const _hoisted_2 = { class: "bar-chart bg-light-purple" }
const _hoisted_3 = { class: "chart-legend row justify-between" }
const _hoisted_4 = { class: "available" }
const _hoisted_5 = { class: "pending" }
const _hoisted_6 = {
  class: "secondary",
  href: "https://dittom.us/pendingroyalties",
  target: "_blank"
}

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import '@popperjs/core'
import Popper from 'vue3-popper'
import Icon from '@/components/CommonUI/Icon.vue'
import Loader from '@/components/CommonUI/Loader.vue'
import Notification from '@/components/CommonUI/Notification.vue'
import PayoutRequestDialog from '@/components/PayoutRequestDialog.vue'
import { formatAmount } from '@/helpers/formatAmount'
import { getErrorMessage } from '@/helpers/errorHandler'


export default /*@__PURE__*/_defineComponent({
  __name: 'BalancePanel',
  emits: ["payout-request-sent"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const store = useStore()

const balance = ref<Balance | null>(null)
const error = ref<string | null>(null)
const dialog = ref<InstanceType<typeof PayoutRequestDialog> | null>(null)

const isWithdrawalReady = computed(() => store.getters.isWithdrawalReady)
const percentageAvailable = computed(() => (
  balance.value
    ? (100 * balance.value.availableBalance) / balance.value.totalBalance
    : 0
))

const getUserBalance = (): Promise<Balance> => store.dispatch('getUserBalance')
const fetchBalance = async (): Promise<void> => {
  balance.value = null
  error.value = null

  try {
    balance.value = await getUserBalance()
  } catch (err) {
    error.value = getErrorMessage(err)
  }
}

const showPayoutDialog = (): void => {
  if (!balance.value || !dialog.value) return
  dialog.value.show(balance.value.availableBalance)
}

const onPayoutRequestSent = (): void => {
  fetchBalance()
  emit('payout-request-sent')
}

onMounted(fetchBalance)

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["balance panel bg-lighter-grey elevate text-center", { loading: !balance.value }])
  }, [
    (error.value)
      ? (_openBlock(), _createBlock(Notification, {
          key: 0,
          "icon-name": "danger",
          title: _ctx.$gettext('Failed retrieving your balance'),
          message: error.value
        }, null, 8, ["title", "message"]))
      : (!balance.value)
        ? (_openBlock(), _createBlock(Loader, { key: 1 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _withDirectives((_openBlock(), _createElementBlock("p", null, [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Your Current Balance ", -1)
            ]))])), [
              [_directive_translate]
            ]),
            _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(formatAmount)(balance.value.totalBalance)), 1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "gauge",
                style: _normalizeStyle(`width: ${balance.value.availableBalance > 0 ? percentageAvailable.value : 0}%`)
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dot bg-indigo" }, null, -1)),
                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Available Balance:", -1)
                ]))])), [
                  [_directive_translate]
                ]),
                _createElementVNode("span", null, " " + _toDisplayString(_unref(formatAmount)(balance.value.availableBalance)), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "dot bg-light-purple" }, null, -1)),
                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Pending:", -1)
                ]))])), [
                  [_directive_translate]
                ]),
                _createElementVNode("span", null, " " + _toDisplayString(_unref(formatAmount)(balance.value.frozenBalance)), 1),
                _createVNode(_unref(Popper), null, {
                  content: _withCtx(() => [
                    _createVNode(Icon, {
                      name: "tooltip",
                      fill: "blue-alternate"
                    }),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$gettext("You can withdraw these royalties once our licensing checks are complete. We'll let you know if there are any issues by email.")) + "   ", 1),
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Learn more about pending royalties ", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(Icon, {
                      name: "tooltip",
                      fill: "blue-alternate",
                      class: "tooltip-link"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            (isWithdrawalReady.value)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: showPayoutDialog
                }, [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Withdraw ", -1)
                ]))])), [
                  [_directive_translate]
                ])
              : _createCommentVNode("", true),
            (isWithdrawalReady.value)
              ? (_openBlock(), _createBlock(PayoutRequestDialog, {
                  key: 1,
                  ref_key: "dialog",
                  ref: dialog,
                  onPayoutRequestSent: onPayoutRequestSent
                }, null, 512))
              : _createCommentVNode("", true)
          ], 64))
  ], 2))
}
}

})